import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file 数值区间类型
 * @author alfielv
 */
import _ from 'lodash';
import React, { useState, useCallback, useMemo } from 'react';
import { Input, Button } from '@tencent/spaui';
export default (function (props) {
  var _props$value = props.value,
      value = _props$value === void 0 ? {
    min: '',
    max: ''
  } : _props$value,
      onChange = props.onChange,
      onClose = props.onClose;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      localValue = _useState2[0],
      setLocalValue = _useState2[1];

  var min = localValue.min,
      max = localValue.max; // 输入校验状态

  var inputStatus = useMemo(function () {
    // max/min转换成number类型
    var maxToNum = _.toNumber(max);

    var minToNum = _.toNumber(min); // 可以转换成number类型的字符串，并排除空字符串


    var maxIsNumber = !_.isNaN(maxToNum) && max !== '';
    var minIsNumber = !_.isNaN(minToNum) && min !== '';

    if (_.isNaN(maxToNum) || _.isNaN(minToNum) || maxIsNumber && minIsNumber && maxToNum < minToNum) {
      return 'error';
    }

    return 'normal';
  }, [min, max]);
  var handleChange = useCallback(function (type, value) {
    setLocalValue(function (pre) {
      return _objectSpread(_objectSpread({}, pre), {}, _defineProperty({}, type, value));
    });
  }, []);
  var onConfirm = useCallback(function () {
    var text = "[".concat(min || '0', " , ").concat(max || '∞', "]");
    onChange === null || onChange === void 0 ? void 0 : onChange({
      text: text,
      value: {
        min: min,
        max: max
      }
    });
  }, [min, max, onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: "number-range-popover"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-row"
  }, /*#__PURE__*/React.createElement(Input, {
    className: "input",
    value: min,
    status: inputStatus,
    onChange: function onChange(evt) {
      return handleChange('min', evt.target.value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "input-split"
  }), /*#__PURE__*/React.createElement(Input, {
    className: "input",
    value: max,
    status: inputStatus,
    onChange: function onChange(evt) {
      return handleChange('max', evt.target.value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose
  }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(Button, {
    displayType: "primary",
    disabled: inputStatus === 'error',
    onClick: onConfirm
  }, "\u786E\u8BA4")));
});